<template>
<div id="register">
  <v-app id="registerapp">
    <v-row justify="center">
      <v-dialog v-model="dialog" content-class="register-dialog">
        <v-card v-if="state_register">
          <v-card-title>
            <span class="headline">{{$t('new_account')}}</span>
              <v-btn text icon large color="primary" class="info-close-btn" @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-0">
              <v-col cols="12" class="mb-0">
            <p class="p1">{{$t('newaccountexp')}}</p>
            <br>
            <p>{{$t('new_account_question')}} <a @click="login">{{$t('connect')}}</a></p>

            <span v-if="error" style="color:red">{{ error }}</span>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  v-bind:label="$t('email')"
                ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    v-bind:label="$t('password')"
                    v-bind:hint="$t('password_hint')"
                    @click:append="show = !show"
                  ></v-text-field>
                  <v-text-field
                    v-model="password_confirm"
                    :rules="[rules.required, rules.min]"
                    type='password'
                    v-bind:label="$t('password_confirm')"
                    v-bind:hint="$t('password_hint')"
                  ></v-text-field>
                   <v-checkbox
                   primary
                  v-model="remember"
                  v-bind:label="$t('remember_me')"
                ></v-checkbox>
            <a :href="$t('data_privacy_link')" target="_blank">{{$t('data_privacy')}}</a>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="register_action">{{$t('create_account')}}</v-btn>
          </v-card-actions>
        </v-card>

         <v-card v-if="state_login">
          <v-card-title>
            <span class="headline">{{$t('connection')}}</span>
              <v-btn text icon large color="primary" class="info-close-btn" @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-row class="mb-0">
              <v-col cols="12" class="mb-0">
            <p class="p1">{{$t('connection_info2')}}:</p>
            <br>
            <p>{{$t('no_account')}}? <a @click="register">{{$t('create_account2')}}</a></p>
                
                <span class="red--text" v-if="error"><br>{{ error }}<br></span>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  v-bind:label="$t('email')"
                ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    v-bind:label="$t('password')"
                    v-bind:hint="$t('password_hint')"
                    counter
                    @click:append="show = !show"
                  ></v-text-field>
                   <v-checkbox
                   primary
                  v-model="remember"
                  v-bind:label="$t('remember_me')"
                ></v-checkbox>
            <p><a @click="recover">{{$t('password_forgotten')}}</a></p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="login_action">{{$t('connect')}}</v-btn>
          </v-card-actions>
        </v-card>

         <v-card v-if="state_recover">
          <v-card-title>
            <span class="headline">{{$t('reset_password')}}</span>
              <v-btn text icon large color="primary" class="info-close-btn" @click="closeDialog">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text v-if="this.sub_state_recover==1">
            <v-row class="mb-0">
              <v-col cols="12" class="mb-0">
            <p class="p1">{{$t('reset_password_info')}}:</p>
                <span class="red--text" v-if="error"><br>{{ error }}<br></span>
            <br>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  v-bind:label="$t('email')"
                ></v-text-field>
                <p><a @click="entercode">{{$t('enter_code')}}</a></p>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-text v-if="this.sub_state_recover==2">
            <v-row class="mb-0">
              <v-col cols="12" class="mb-0">
            <p class="p1">{{$t('confirm_code_text')}}:</p>
                <span class="red--text" v-if="error"><br>{{ error }}<br></span>
            <br>
                <v-text-field
                  v-model="email"
                  :rules="[rules.required, rules.email]"
                  v-bind:label="$t('email')"
                ></v-text-field>
                 <v-text-field
                  v-model="recovery_code"
                  :rules="[rules.required]"
                  v-bind:label="$t('init_code')"
                ></v-text-field>

                  <v-text-field
                    v-model="password"
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="show ? 'text' : 'password'"
                    v-bind:label="$t('password')"
                    v-bind:hint="$t('password_hint')"
                    @click:append="show = !show"
                  ></v-text-field>
                  <v-text-field
                    v-model="password_confirm"
                    :rules="[rules.required, rules.min]"
                    type='password'
                    v-bind:label="$t('password_confirm')"
                    v-bind:hint="$t('password_hint')"
                  ></v-text-field>
                <p v-if="this.sub_state_recover==1"><a @click="entercode">{{$t('enter_code')}}</a></p>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="recover_request_action" v-if="this.sub_state_recover==1">{{$t('recover')}}</v-btn>
           <v-btn color="primary" rounded depressed large class="info-submit-btn" @click="recover_action" v-if="this.sub_state_recover==2">{{$t('reset')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-app>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Register',
  data () {
    return {
      dialog: false,
      state_register: true,
      state_login: false,
      state_recover: false,
      sub_state_recover:1,
      show: false,
      email: '',
      email_confirm: '',
      remember: true,
      password: '',
      password_confirm: '',
      error: '',
      rules: {
          required: value => !!value || this.$t('mandatory'),
          min: v => v.length >= 8 || this.$t('password_hint'),
          emailMatch: () => (this.$t('mail_confirm_error')),
          passwordMatch: () => (this.$t('password_confirm_error')),
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || this.$t('invalid_email')}
      },
    }
  },
  props: [ 'showCalculatorDialog', 'getLastCalculation' ],
  computed: {
  },
  methods: {
    login_action(){
      var data = {}
      data['email'] = this.email
      data['password'] = this.password
      axios.post(this.$store.backendAPI+'users/login/', data)
      .then(response => {
        if (response.status == 200){
          this.$store.userToken = response.data.token
          this.$store.userEmail = response.data.userEmail
          if (this.remember){
            this.$cookies.set('token', this.$store.userToken)
          }
          this.getLastCalculation()
          this.showCalculatorDialog()

        }

      })
      .catch(e => {
        console.log(e)
         this.error = this.$t('login_error')
      })
    },
    register_action(){
      if (this.email.length > 5  && this.password == this.password_confirm){
        var data = {}
        data['email'] = this.email
        data['password'] = this.password
        data['password_confirm'] = this.password_confirm
        axios.post(this.$store.backendAPI+'users/', data)
        .then(response => {
          if (response.status == 200){
            this.$store.userToken = response.data.token
            this.$store.userEmail = response.data.userEmail
            if (this.remember){
              this.$cookies.set('token', this.$store.userToken)
            }
            this.showCalculatorDialog()

          }
          console.log(response)

        })
        .catch(e => {
          console.log(e)
           if (e.response.data.error){
              this.error = e.response.data.error
            }
        })
      }

    },
    recover_request_action(){
      var data = {}
      data['email'] = this.email
      axios.post(this.$store.backendAPI+'users/requestrecovery/', data)
      .then(response => {
        if (response.status == 200){
          this.error = ''
          // this.$store.userToken = response.data.token
          // if (this.remember){
          //   this.$cookies.set('token', this.$store.userToken)
          // }
          // this.showCalculatorDialog()
          console.log("ok")
          this.sub_state_recover = 2

        }

      })
      .catch(e => {
        console.log(e)
         this.error = this.$t('email_recovery_error')
      })

    },
    recover_action(){
      var data = {}
      data['email'] = this.email
      data['recovery_code'] = this.recovery_code
      data['password'] = this.password
      data['password_confirm'] = this.password_confirm
      axios.post(this.$store.backendAPI+'users/recover/', data)
      .then(response => {
        if (response.status == 200){
          this.error = ''
          this.$store.userToken = response.data.token
          if (this.remember){
            this.$cookies.set('token', this.$store.userToken)
          }
          this.getLastCalculation()
          this.showCalculatorDialog()

        }

      })
      .catch(e => {
        console.log(e)
         this.error = e.response.data.error
      })

    },
    login(){
      console.log("login")
      this.state_register = false
      this.state_recover = false
      this.state_login = true
      this.error = ''
      this.email = ''
      this.password = ''
      this.password_confirm = ''
      this.$router.push({ name: 'login', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
    },
    register(){
      console.log("register")
      this.state_register = true
      this.state_recover = false
      this.state_login = false
      this.error = ''
      this.email = ''
      this.password = ''
      this.password_confirm = ''
      this.$router.push({ name: 'register', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
    },
    recover(){
      console.log("recover")
      this.state_register = false
      this.state_recover = true
      this.state_login = false
      this.error = ''
      this.email = ''
      this.substate_recover = 1
      this.$router.push({ name: 'recover', params: { locale: this.$store.lang, mapid:this.$store.mapParameters.hash  }})
    },
    entercode(){
      this.sub_state_recover = 2
    },
    back() {
      return true
    },
    openDialog(){
      this.sub_state_recover = 1
      this.email = ''
      this.email_confirm = ''
      this.password = ''
      this.password_confirm = ''
      this.rememeber = false
      this.dialog = true
      this.register()
    },
    closeDialog(){
      this.dialog = false
    }
  }

}
</script>

